<template>
  <div class="headline wh100" v-html="value.split('\n').join('<br>')">
  </div>

</template>

<script>
  export default {
    name: "headline",
    props: ['value']
  }
</script>

<style lang="scss" scoped>
  .headline {
    font-size: 1.6rem;
    font-weight: 400;
    margin-bottom: 0.3rem;
    line-height: 1.6rem;
    @media screen and (max-width: 375px) {
      font-size: 1.3rem;
      line-height: 1.3rem;
    }
    @media screen and (max-width: 320px) {
      font-size: 1.3rem;
      line-height: 1.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/Headline.vue